import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import TranslateIcon from "@mui/icons-material/Translate";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";

import CustomForm from "../../../helper-components/form/CustomForm.jsx";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter.jsx";

import TextTranslationTable from "./components/TextTranslationTable.jsx";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The highlight requests page.
 */
export default function TextTranslations(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().TEXT_TRANSLATIONS_TITLE} subtitle={getLanguage().TEXT_TRANSLATIONS_SUBTITLE} icon={<TranslateIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <TextTranslationTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/translations/audio`,
                            title: "Audio translations",
                            variant: "outlined",
                            icon: <AudiotrackIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
